import React from "react"

import { AttachmentFragment } from "entities/attachments/graphql/fragments.generated"

import { DeleteAttachmentOverlay } from "./DeleteAttachmentOverlay"
import { useDeleteAttachmentOverlayModel } from "./model/useDeleteAttachmentOverlayModel"

export interface DeleteAttachmentOverlayPayload {
  projectID: string
  attachment: AttachmentFragment
}

export interface DeleteAttachmentOverlayConnectorProps {
  payload: DeleteAttachmentOverlayPayload
}

export const DeleteAttachmentOverlayConnector = React.memo(
  (props: DeleteAttachmentOverlayConnectorProps) => (
    <DeleteAttachmentOverlay {...useDeleteAttachmentOverlayModel(props)} />
  )
)

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    DELETE_ATTACHMENT_OVERLAY: DeleteAttachmentOverlayPayload
  }
}
